import { $http } from '@/services/http-common'

export default {
  getPlans () {
    return $http.get('/api/plans')
  }
}
